import { Radio, Row, Col } from 'antd';
import React from 'react';

export default function StyledRadio({ color, text, status, count, disabled }) {

	return <Radio.Button
			disabled={disabled}
			value={status}
			size='large'
			style={{
				height: '100px',
				borderRadius: '0.5rem',
				width: '200px',
				margin: '1rem',
			}}>
			<Row justify='center' align='middle'>
				<Col
					span={2}
					style={{
						background: color,
						height: '100px',
						width: '30px',
						borderRadius: '0.5rem',
					}}></Col>
				<Col span={18} offset={2}>
					<div style={{ textAlign: 'center' }}>
						{text}
						<br />
						<span>{count}</span>
					</div>
				</Col>
			</Row>
		</Radio.Button>;
}
